import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getBaseUrl } from '../../utils/general/getBaseUrl';
import { USER_ROLE } from '../../utils/constants/user-role.constants';
import {baseQueryWithReauth} from "@states/auth/auth.api";

export const userRoleApi = createApi({
    reducerPath: 'userRoleApi',
    tagTypes: ['userRoleApi'],
    baseQuery: baseQueryWithReauth,
    // baseQuery: fetchBaseQuery({
    //     baseUrl: getBaseUrl(),
    // }),
    endpoints: (builder) => ({
        getAllUserRoles: builder.query<
            [],
            { page?: number; limit?: number; user_role_name?: string }
        >({
            query: ({ page = 1, limit = 10, user_role_name }) => {
                const queryParams = {
                    url: USER_ROLE.GET_ALL,
                    params: { page, limit },
                };

                if (user_role_name) {
                    //@ts-ignore
                    queryParams.params.user_role_name = user_role_name;
                }

                return queryParams;
            },
        }),
        createUserRole: builder.mutation({
            query: (body) => ({
                url: USER_ROLE.CREATE,
                method: 'POST',
                body,
            }),
        }),
        updateUserRole: builder.mutation({
            query: ({ id, body }) => ({
                url: `${USER_ROLE.UPDATE}${id}`,
                method: 'PATCH',
                body,
            }),
        }),
        deleteUserRole: builder.mutation({
            query: (id) => ({
                url: `${USER_ROLE.DELETE}${id}`,
                method: 'DELETE',
            }),
        }),
    }),
    keepUnusedDataFor:0
});

export const {
    useGetAllUserRolesQuery,
    useCreateUserRoleMutation,
    useUpdateUserRoleMutation,
    useDeleteUserRoleMutation,
} = userRoleApi;
